import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { MojoNumericInputComponent } from './mojo-numeric-input.component';

@NgModule({
  declarations: [MojoNumericInputComponent],
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatIconModule],
  exports: [MojoNumericInputComponent],
})
export class MojoNumericInputModule {}
